import { useState } from "react";
import { homeService } from "@miplatform/api";
import { useComponentState } from "@miplatform/hooks";
import { IApiRequest, IMaterialsResponse } from "@miplatform/types";

export const useCustomerMaterials = () => {
  const [customerMaterials, setCustomerMaterials] = useState<
    IMaterialsResponse[]
  >([]);

  const stateManager = useComponentState();

  const getCustomerMaterials = ({
    accountId,
    filters,
    sort = { category: ["categoryName", "itemCode"] },
    top,
  }: ICustomerRequest) => {
    return stateManager.run((signal: AbortSignal) => {
      return homeService.accountConfigs.materials.getAll({
        id: accountId,
        sort,
        filters,
        top,
        signal,
      });
    });
  };

  const updateCustomerMaterials = (
    accountId: string,
    materials: { id: string; netSalesPrice?: number | null }[],
    toastMessageConfig?: {
      success?: { text?: string };
      failure?: { text?: string };
    }
  ) => {
    return stateManager.run(() => {
      return homeService.accountConfigs.materials.update({
        id: accountId,
        data: materials,
        toastMessageConfig,
      });
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    customerMaterials,
    setCustomerMaterials,
    getCustomerMaterials,
    updateCustomerMaterials,
  };
};

type ICustomerRequest = IApiRequest & {
  accountId: string;
};
